export default "\r\n    <app-job-day [job]=\"jobs\"></app-job-day>\r\n\r\n"